import hmacSHA256 from "crypto-js/hmac-sha256";
import hex from "crypto-js/enc-hex";

// const regx = /@(.+?)\s/g;

export default class Common {// 防抖
  static getStorageItem(name) {
    return window.localStorage.getItem(name);
  }

  static debounce(fun, waitTime = 500) {
    let timeout = null;

    return function() {
      const self = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        fun.apply(self, Array.prototype.slice.call(arguments));
      }, waitTime);
    };
  }

  static dateFtt(fmt, date) {
    //author: meizz
    var o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return fmt;
  }

  static sha256Encrypt(
    value,
    key = "Zbxn5@RnZzq&GbFG8Ie0YMN$^xhl9Id7U8lLf3J8AkpBpQyU6pllsMPRv^b0qfAt^GpVJnd&GVQVD&Bs_WaxvoNK*A#f7yR^DB9d^fEuB!H%RxwQzZ1"
  ) {
    return hmacSHA256(value, key).toString(hex);
  }

  static setStorageItem(name, value) {
    window.localStorage.setItem(name, value);
  }

  // 获取url参数
  static getUrlParams(paras) {
    const reg = new RegExp("(^|&)" + paras + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if (r) {
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    } else {
      var url = location.href;
      var paraArr = url.split("?");
      var paraString = paraArr[paraArr.length - 1].split("&");
      var paraObj = {};
      let j;

      for (let i = 0; paraString[i]; i++) {
        j = paraString[i];
        paraObj[j.substring(0, j.indexOf("=")).toLowerCase()] = j.substring(
          j.indexOf("=") + 1,
          j.length
        );
      }
      var returnValue = paraObj[paras.toLowerCase()];
      if (typeof returnValue == "undefined") {
        return "";
      } else {
        return returnValue;
      }
    }
  }

}
